/** A row of the phone menu. `min-h-touch` is 44 px, in px so it does not grow with the text size. */
export function phoneRowClasses({ isActive }: { isActive: boolean }): string {
  return `flex min-h-touch w-full items-center gap-3 rounded-lg px-3 py-2 text-left text-[15px] font-medium leading-5 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-focus ${
    isActive
      ? 'bg-[#D7DBDC]/75 text-gray-950 dark:bg-[#303030] dark:text-white'
      : 'text-gray-700 active:bg-[#D7DBDC]/60 dark:text-gray-200 dark:active:bg-[#2a2a2a]'
  }`;
}
